/** Lifetime of a preview's object URL: long enough for the new tab to load it. */
const PREVIEW_URL_LIFETIME_MS = 60_000;

/** Saves a blob under `filename` through a temporary link. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

/**
 * Opens a tab right away, while still inside the click handler: a tab opened
 * once an HTTP call has answered is no longer tied to the click, and popup
 * blockers stop it. Fill it with {@link showBlobInTab}, or close it on error.
 */
export function openPreviewTab(): Window | null {
  return window.open('', '_blank');
}

/**
 * Shows a blob in a tab from {@link openPreviewTab}: the browser renders PDFs
 * and images itself. The blob keeps the response's content type, which is what
 * lets it pick the viewer. Falls back to saving the file when no tab could be
 * opened.
 */
export function showBlobInTab(
  tab: Window | null,
  blob: Blob,
  fallbackFilename: string
): void {
  if (!tab || tab.closed) {
    saveBlob(blob, fallbackFilename);
    return;
  }
  const url = URL.createObjectURL(blob);
  tab.location.href = url;
  setTimeout(() => URL.revokeObjectURL(url), PREVIEW_URL_LIFETIME_MS);
}
